var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "page-summary-card clickable" }, [
    _c(
      "div",
      { staticClass: "card-block", on: { click: _vm.openCardPreview } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "typography--body-3" }, [
              _c("strong", { staticClass: "typography--color-secondary" }, [
                _vm._v(_vm._s(_vm.index + 1))
              ]),
              _vm._v(" "),
              _vm.page.is_quiz
                ? _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.quiz")))]
                  )
                : _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.non_quiz")))]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "page-content-container",
                class: _vm.classBindings
              },
              [
                _vm.hasImage
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.firstImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudio
                  ? _c("div", { staticClass: "page-audio-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-audio.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstAudioDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasVideo || _vm.hasEmbededVideo
                  ? _c("div", { staticClass: "page-video-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-video.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstVideoDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "typography--body-2 typography--pre-line page-content",
                  domProps: { innerHTML: _vm._s(_vm.pageContent) }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-018cdf99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-018cdf99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/library/components/PageSummary.vue
// module id = TXvb
// module chunks = 1